import { NgModule } from '@angular/core';
import { CommonModule } from 'app/common.module';
import { ComboButtonModule } from 'shared/components/combo-button/combo-button.module';
import { InfopostTspSelectorComponent } from './infopost-tsp-selector.component';
@NgModule({
    imports: [CommonModule, ComboButtonModule],
    exports: [InfopostTspSelectorComponent],
    declarations: [InfopostTspSelectorComponent],
})
export class InfoPostTspSelectorModule { }
